module.exports = __webpack_public_path__ + "static/img/prototype.d9344cba.png";